import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import Home from "pages/home";
import { createContext } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Balance from "./pages/balance";
import Login from "./pages/login/Login";
import Messages from "./pages/messages";
import Mobile from "./pages/mobileApps";
import Policy from "pages/policy";
export const Context = createContext("Default Value");
const firebaseConfig = {
  apiKey: "AIzaSyC7zfQOlDiJ9Unyeee8ZahLL_jeEk9OxZo",
  authDomain: "door2door-76ca3.firebaseapp.com",
  databaseURL: "https://door2door-76ca3.firebaseio.com",
  projectId: "door2door-76ca3",
  storageBucket: "door2door-76ca3.appspot.com",
  messagingSenderId: "6055570640",
  appId: "1:6055570640:web:be67169df83829b60142d5",
  measurementId: "G-1FSC523X2R",
};
const app = initializeApp(firebaseConfig);

export const database = getDatabase(app);
export const auth = getAuth(app);

function App() {
  // Initialize Firebase

  return (
    <BrowserRouter>
      <Context.Provider value={10}>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />}>
              {" "}
            </Route>
            <Route path="/balance" element={<Balance />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/mobile" element={<Mobile />} />
            <Route path="/policy" element={<Policy />} />
          </Routes>
        </div>
      </Context.Provider>
    </BrowserRouter>
  );
}

export default App;
